<template>
  <component
    :is="banner.link ? 'a' : 'div'"
    :href="banner.link"
    class="in-grid-banner"
    :class="{'double-width': banner.double_width}"
  >
    <div
      class="in-grid-banner__image"
      :class="imageClasses"
      :style="imageStyles"
    />

    <div class="in-grid-banner__text">
      <p
        v-if="banner.copy"
        class="in-grid-banner__copy text-other-label-bold"
        v-html="banner.copy"
      />

      <span
        v-if="banner.cta_copy"
        class="in-grid-banner__cta-copy text-body-m-regular"
        v-html="banner.cta_copy"
      />
    </div>
  </component>
</template>

<script>

/**
 * Vue: In-Grid banner (in-grid-banner)
 * -----------------------------------------------------------------------------
 * Banner populated by a metaobject that renders in the PLP grid.
 *
 * @param {Object} banner - Banner content from metaobject settings.
 * @param {Number} cardImageHeight - Product card image height.
 */

export default {
  name: 'InGridBanner',

  props: {
    banner: {
      type: Object,
      default: () => ({}),
    },
    cardImageHeight: {
      type: Number,
      default: 0,
      required: true,
    },
  },

  computed: {

    /**
     * Classes for positioning the background image
     * @returns {String}
     */
    imageClasses() {
      let classes = ''

      if (this.banner.image.position_x) {
        classes += `position-x-${this.banner.image.position_x.toLowerCase()}`
      }

      if (this.banner.image.position_y) {
        classes += ` position-y-${this.banner.image.position_y.toLowerCase()}`
      }

      return classes
    },

    /**
     * Inline styles for image.
     */
    imageStyles() {
      return `
        background-image: url(${this.banner.image.src});
        height: ${this.cardImageHeight}px;
      `
    },
  },
}
</script>

<style lang="scss">
@import './in-grid-banner';
</style>
